import React, {Component} from "react";
import "../../VisitHistory.css"
import {getReviewOfSystemNormalText} from "../../../assessment/checkers/AssessmentReviewOfSystemChecker";

export default class AssessmentReviewOfSystemViewHistory extends Component {

    dataFields = [
        {
            title: "Cardiovascular / Circulatory",
            field: "cardiovascularCirculatory"
        }, {
            title: "Respiratory",
            field: "respiratory"
        }, {
            title: "Head, Neck, Eyes",
            field: "headNeckEyes"
        }, {
            title: "ENT",
            field: "ent"
        }, {
            title: "Skin, Hair, Nails",
            field: "skinHairNails"
        }, {
            title: "Lymphatic / Immune",
            field: "lymphaticImmune"
        }, {
            title: "Endocrine",
            field: "endocrine"
        }, {
            title: "Gastrointestinal",
            field: "gastrointestinal"
        }, {
            title: "Genitourinary",
            field: "genitourinary"
        }, {
            title: "Musculoskeletal",
            field: "musculoskeletal"
        }, {
            title: "Neurological",
            field: "neurological"
        },
    ];

    render() {
        if (this.props.reviewOfSystem == null) {
            return <div className={this.props.reportView ? "" : "pl-3"}>No information available</div>;
        }

        return (
            <div className={"visit-history-multiple-content-wrapper"}>
                {this.getContents()}
            </div>
        );
    }

    getContents() {
        let contents = [];
        this.dataFields.forEach((data, index) => {
            const field = this.props.reviewOfSystem[data.field];
            const fieldIsNormal = this.props.reviewOfSystem[data.field + "Normal"];

            const statusName = getReviewOfSystemNormalText(fieldIsNormal);
            contents.push(
                <div className="pl-3">
                    <div key={"reviewOfSystemViewHistory" + index}>
                        <div className={"display-flex"} style={{margin: "3px"}}>
                            <div className={"col-sm-3 no-padding dim14-form-label"}>{data.title}</div>
                            <div
                                className={"col-sm-9 no-padding overflow-wrap-anywhere"}>{`: 
                                ${(field != null && field.length > 0)
                                ? field.join(", ")
                                : statusName}`}</div>
                        </div>
                    </div>
                </div>
            );
        });
        return contents;
    }
}